import React from "react";
import PropTypes from "prop-types";

import Size from "components/Size";
import { objectValueNotZero, Translate } from "utils";

import styles from "./SpaceSize.css";

const { t } = new Translate();

const CapacityPrimary = ({ area, capacity, isUnitBlack, isValueBold }) => (
  <div className={styles.root}>
    <div className={styles.linked}>
      {objectValueNotZero(area) && (
        <Size
          isUnitBlack={isUnitBlack}
          isValueBold={isValueBold}
          unit={area.unit}
          value={area.value}
        />
      )}
      {objectValueNotZero(area) && objectValueNotZero(capacity) && (
        <div className={styles.linkingWord}>{t("with")}</div>
      )}
    </div>
    {objectValueNotZero(capacity) && (
      <Size
        isUnitBlack={isUnitBlack}
        isValueBold={isValueBold}
        unit={capacity.unit}
        value={capacity.value}
      />
    )}
  </div>
);

CapacityPrimary.propTypes = {
  area: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    unit: PropTypes.string,
  }),
  capacity: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    unit: PropTypes.string,
  }),
  isUnitBlack: PropTypes.bool,
  isValueBold: PropTypes.bool,
};

export default CapacityPrimary;
